import { __awaiter, __generator } from "tslib";
import { json } from '../pipes/json';
import { status } from '../pipes/status';
import { getHttpStoreKey } from '../utilities/get-http-store-key';
import { httpStore } from '../utilities/http-store';
/**
 * @internal
 */
export var commonFetch = function (url, options) { return __awaiter(void 0, void 0, void 0, function () {
    var storeKey, promise;
    return __generator(this, function (_a) {
        storeKey = getHttpStoreKey(url, options);
        promise = httpStore.get(storeKey);
        if (!promise) {
            promise = new Promise(function (resolve, reject) {
                fetch(url, options)
                    .then(status)
                    .then(json)
                    .then(resolve)
                    .catch(reject);
            });
            httpStore.set(storeKey, promise);
        }
        return [2 /*return*/, promise];
    });
}); };
